// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NowRouteImport } from './routes/now'
import { Route as GardenRouteImport } from './routes/garden'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GardenSlugRouteImport } from './routes/garden.$slug'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const NowRoute = NowRouteImport.update({
            id: '/now',path: '/now',getParentRoute: () => rootRouteImport
          })
const GardenRoute = GardenRouteImport.update({
            id: '/garden',path: '/garden',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const GardenSlugRoute = GardenSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GardenRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const GardenRouteChildren = {
  GardenSlugRoute: GardenSlugRoute
}

const GardenRouteWithChildren = GardenRoute._addFileChildren(GardenRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,GardenRoute: GardenRouteWithChildren,NowRoute: NowRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)